import { useRef } from 'react';
import { useLocation } from 'react-router';

import { useNavigationHistory } from './useNavigationHistory';

/**
 * Hook to call a function when the location changes.
 * @param callback {Function} The callback function.
 * @returns void
 */
export const useOnLocationChange = (callback: Function) => {
  const { pathname } = useLocation();
  const previousRef = useRef(pathname);
  const { previousLocation } = useNavigationHistory();

  if (pathname !== previousRef.current) {
    previousRef.current = pathname;
    callback();
  }

  return {
    previousLocation,
  };
};
